import { useEffect, useState } from 'react'
import { useScreenSizeUp } from 'hooks/useScreenSize'
import { OFFER_LIST_CAROUSEL_DEFAULT_LIMIT } from './offerListCarouselConstants'

export function resolveOfferListCarouselDisplayLimit(
  limit: number,
  tabletLimit: number | 'default',
  isTabletScreenSizeAndHigher: boolean,
): number {
  if (isTabletScreenSizeAndHigher && tabletLimit) {
    return tabletLimit === 'default' ? OFFER_LIST_CAROUSEL_DEFAULT_LIMIT : tabletLimit
  }

  return limit
}

function useOfferListCarouselDisplayLimit(
  limit: number = OFFER_LIST_CAROUSEL_DEFAULT_LIMIT,
  tabletLimit: number | 'default' = limit,
): number {
  const isTabletScreenSizeAndHigher = useScreenSizeUp('tablet')
  const [listLimit, setListLimit] = useState(limit)

  useEffect(() => {
    setListLimit(resolveOfferListCarouselDisplayLimit(limit, tabletLimit, isTabletScreenSizeAndHigher))
  }, [isTabletScreenSizeAndHigher, limit, tabletLimit])

  return listLimit
}

export default useOfferListCarouselDisplayLimit
